import {Component, computed, input, model, OnDestroy, OnInit} from '@angular/core';
import {NgForOf, NgIf} from "@angular/common";
import {AlertService} from "../../../../common/alert/alert.service";
import {Subscription} from "rxjs";
import {Licenses, PinholeLicenseService,} from "../../services/pinhole.license.service";
import {AddServerLicenseComponent} from "../add-server-license/add-server-license.component";

@Component({
    selector: 'license-info',
    templateUrl: './license.component.html',
    imports: [
        NgIf,
        NgForOf,
        AddServerLicenseComponent
    ],
    styleUrls: ['./license.component.css']
})
export class LicenseComponent implements OnDestroy, OnInit {
    private subscriptions: Subscription[] = [];
    readonly iid = input.required<string>()
    readonly licenses = model<Licenses | null>(null);

    readonly active = computed(() => this.licenses()?.active)
    readonly serverAdded = computed(() => this.licenses()?.serverAdded)
    readonly purchases = computed(() => this.licenses()?.purchases ?? [])

    constructor(private service: PinholeLicenseService, private alertService: AlertService) {

    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe())
    }

    ngOnInit() {
        this.getLicense();
    }

    getLicense() {
        this.alertService.clearAlerts();
        this.licenses.set(null);
        this.subscriptions.push(
            this.service
                .findLicense(this.iid())
                .subscribe(value => {
                    if (value != null) {
                        this.licenses.set(value);
                    } else {
                        this.alertService.showAlert('danger', "Not found");
                    }
                })
        );
    }
}